import {
    ContentDataDefinitionLoader,
    createRegisterableComponentWithData,
} from '@news-mono/web-common'
import { Pagination, PaginationProps } from './Pagination'
import React from 'react'

type PaginationRegistrationProps = Omit<
    PaginationProps,
    'dataDefinition' | 'data' | 'services'
>

export const PaginationRegistration = createRegisterableComponentWithData(
    'pagination',
    ContentDataDefinitionLoader,
    (
        { contextId }: PaginationRegistrationProps,
        { dataDefinitionArgs, ...data },
        services,
    ) => (
        <Pagination
            contextId={contextId}
            dataDefinition={dataDefinitionArgs}
            data={data}
            services={services}
        />
    ),
)
